<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<ng-container *ngIf="redirectToParceiro; else templateVerificacaoUnico">
  <app-verificacao-seguranca-clearsale></app-verificacao-seguranca-clearsale>
</ng-container>

<ng-template #templateVerificacaoUnico>
  <app-verificacao-seguranca-unico></app-verificacao-seguranca-unico>
</ng-template>
